import { render } from "./ClientAuth.vue?vue&type=template&id=b80801f0&scoped=true"
import script from "./ClientAuth.vue?vue&type=script&lang=js"
export * from "./ClientAuth.vue?vue&type=script&lang=js"

import "./ClientAuth.vue?vue&type=style&index=0&id=b80801f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80801f0"]])

export default __exports__